import { Get, Post, Put, Patch, Delete, RequestUse } from 'skytech-request';
import { getRequestUse } from 'sky-domain';
RequestUse(getRequestUse);
export { Get, Post, Put, Patch, Delete };
